__turbopack_context__.v({
  "component": "style-module-scss-module__fVLglG__component",
  "is-private": "style-module-scss-module__fVLglG__is-private",
});
